enum ComparisonOperators {
    LessThan = 1,
    GreaterThan = 2,
    LessThanOrEqualTo = 4,
    GreaterThanOrEqualTo = 8,
    EqualTo = 16,
    NotEqualTo = 32
}

export default ComparisonOperators;
